import React, {ReactNode, useCallback, useMemo, useState} from 'react';

import {AiUsageContext} from './context';

type Props = {
    children: ReactNode,
};

export const AiUsageProvider = ({children}: Props) => {
    const [usedRequests, setUsedRequests] = useState<number[]>([]);

    const setAiUsed = useCallback((changeRequestId: number) => {
        setUsedRequests(prev => [...new Set([...prev, changeRequestId])]);
    }, []);

    const checkFeedbackModal = useCallback(
        (changeRequestId: number) => usedRequests.includes(changeRequestId),
        [usedRequests],
    );

    const cleanAiUsed = useCallback((changeRequestId: number) => {
        setUsedRequests(prev => prev.filter(id => id !== changeRequestId));
    }, []);

    const contextValue = useMemo(
        () => ({
            setAiUsed,
            cleanAiUsed,
            checkFeedbackModal,
        }),
        [setAiUsed, cleanAiUsed, checkFeedbackModal],
    );

    return (
        <AiUsageContext.Provider value={contextValue}>
            {children}
        </AiUsageContext.Provider>
    );
};
